export default function (Vue) {
  Vue.auth = {
    // set token enregistre le token dans le navigateur
    setToken (token, expiration) {
      localStorage.setItem('token', token)
      localStorage.setItem('expiration', expiration)
    },
    setImpersonateToken (token) {
      localStorage.setItem('impersonation_token', token)
      localStorage.setItem('impersonation_expiration', Date.now() + (60 * 5 * 1000))
    },
    // recupere le token actuel
    getToken () {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('impersonate_token')) {
        this.setImpersonateToken(urlParams.get('impersonate_token'))
      }

      const impersonationToken = localStorage.getItem('impersonation_token')
      const impersonationExpiration = localStorage.getItem('impersonation_expiration')

      if (impersonationToken && impersonationExpiration && Date.now() < parseInt(impersonationExpiration)) {
        return impersonationToken
      }
      const token = localStorage.getItem('token')
      const expiration = localStorage.getItem('expiration')

      if (!token || !expiration) {
        return null
      }

      if (Date.now() > parseInt(expiration)) {
        this.destroyToken()
        return null
      } else {
        return token
      }
    },
    isImpersonating () {
      return localStorage.getItem('impersonation_token') !== null
    },
    destroyImpersonationToken () {
      localStorage.removeItem('impersonation_token')
      localStorage.removeItem('impersonation_expiration')
    },
    // suprime le token pour le logout
    destroyToken () {
      localStorage.removeItem('token')
      localStorage.removeItem('expiration')
      localStorage.removeItem('status')
    },
    /* sauvgarde du status compte lors de la connexion */
    setStatusCompte (status) {
      localStorage.setItem('status', status)
    },
    getStatusCompte () {
      const status = localStorage.getItem('status')
      return status
    },
    // si l'utilisateur est connecté
    isAuthenticated () {
      if (this.getToken()) {
        return true
      } else {
        return false
      }
    }

  }

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get: () => {
        return Vue.auth
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/packages/auth/Auth.js